import {IonicImageCacheHelperProvider} from 'ionic3-image-cache';
import {Events} from 'ionic-angular';
import {FileTransfer} from '@ionic-native/file-transfer';
import {File} from '@ionic-native/file';
import {NgZone} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

const win: any = window;

export class CustomImageCacheHelperProvider extends IonicImageCacheHelperProvider {

  constructor(event: Events, transfer: FileTransfer, file: File, ngZone: NgZone, private sanitizer: DomSanitizer) {
    super(event, transfer, file, ngZone);
  }

  safeiOSNativeURL(url: string): any {
    return this.sanitizer.bypassSecurityTrustUrl(win.Ionic.WebView.convertFileSrc(url));
  }
}



// WEBPACK FOOTER //
// ./src/classes/CustomImageCacheHelperProvider.ts